import React, { useState } from 'react'
import { Button, Grid, Message } from 'semantic-ui-react'
import { Product } from '../../../hooks/useProduct'
import { Alias } from '../../../redux/types/products'
import { navigateToProductAliasRemap } from '../../../utils/navigate'
import { handleGenericErrors } from '../../../utils/Products/errorHandler'
import { remapAlias } from './api/remap'

interface AliasRemapControlsProps {
  alias: Alias | null
  fromProduct: Product | null
  toProduct: Product | null
  onCancel: () => void
}

interface MessageType {
  error?: boolean
  positive?: true
  content?: string
  header?: string
}

export const AliasRemapControls = ({
  alias,
  fromProduct,
  toProduct,
  onCancel,
}: AliasRemapControlsProps) => {
  const enableSubmit = !(alias && fromProduct && toProduct)
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [message, setMessage] = useState<MessageType | undefined>()

  const handleSubmit = async () => {
    if (!(alias && fromProduct && toProduct)) return

    setIsSubmitting(true)
    const [error, response] = await remapAlias(alias.id, toProduct.id)

    if (error) {
      const message: MessageType = {
        error: true,
        header: 'Remap Failed',
        content: 'There was an unknown error remapping this alias.',
      }

      if (error?.response?.data?.errors?.error) {
        message.content = error.response.data.errors.error
      }

      setMessage(message)
      handleGenericErrors(error)
    } else if (response) {
      const responseAlias = response?.data.alias
      setMessage({
        positive: true,
        header: 'Alias remapped successfully!',
        content: `Alias #${responseAlias.id} '${responseAlias.name}' has been successfully \
                  remapped from Product #${fromProduct.id} to Product #${responseAlias.product_id}`,
      })
      navigateToProductAliasRemap({
        productId: responseAlias.product_id,
        aliasId: responseAlias.id,
      })
    }
    setIsSubmitting(false)
  }
  return (
    <Grid stackable>
      <Grid.Column width={11}>
        {message && <Message {...message} onDismiss={() => setMessage(undefined)} />}
      </Grid.Column>
      <Grid.Column width={5} textAlign="right">
        <div>
          <Button
            style={{ marginBottom: 5 }}
            size="large"
            onClick={(e) => {
              e.preventDefault()
              onCancel()
            }}
          >
            Close
          </Button>
          <Button
            style={{}}
            primary
            size="large"
            disabled={enableSubmit || isSubmitting}
            onClick={(e) => {
              e.preventDefault()
              handleSubmit()
            }}
          >
            {isSubmitting ? 'Remapping...' : 'Confirm'}
          </Button>
        </div>
      </Grid.Column>
    </Grid>
  )
}
